import {
  SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_BEGIN,
  SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_SUCCESS,
  SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_FAILURE,
  SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';
import { ErrorAction } from '../../common/redux/toasts';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function confirmEditCuotaAsync({ body = {} , id = '' } = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
     
      const doRequest = axios.post(REACT_APP_API_SF + "/formule", body);
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_SUCCESS,
            data: res.data.data,
            id: id
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_FAILURE,
            data: { error: err },
          });
          ErrorAction({
            title: err?.response?.data?.message || 'Hubo un error en el cálculo de CFT'
          })
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissConfirmEditCuotaAsyncError() {
  return {
    type: SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        confirmEditCuotaAsyncPending: true,
        confirmEditCuotaAsyncError: null,
      };

    case SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_SUCCESS:
      // The request is success
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        let cuotas = state.editLineaData.datosFinancieros.cuotas;
        let cuotasPreviousValues = state.editLineaData.datosFinancieros.cuotasPreviousValues;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.cft = action.data.CFT;
            cuota.tir = action.data.Tir;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        cuotasPreviousValues.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.cft = action.data.CFT;
            cuota.tir = action.data.Tir;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        editLineaData.datosFinancieros.cuotas = cuotas;
        editLineaData.datosFinancieros.cuotasPreviousValues = cuotasPreviousValues;
        return {
          ...state,
          editLineaData: editLineaData,
          confirmEditCuotaAsyncPending: false,
          confirmEditCuotaAsyncError: null,
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let cuotas = state.altaNuevaLinea.datosFinancieros.cuotas;
        let cuotasPreviousValues = state.altaNuevaLinea.datosFinancieros.cuotasPreviousValues;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.cft = action.data.CFT;
            cuota.tir = action.data.Tir;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        cuotasPreviousValues.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.cft = action.data.CFT;
            cuota.tir = action.data.Tir;
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        altaNuevaLinea.datosFinancieros.cuotas = cuotas;
        altaNuevaLinea.datosFinancieros.cuotasPreviousValues = cuotasPreviousValues;
        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea,
          confirmEditCuotaAsyncPending: false,
          confirmEditCuotaAsyncError: null,
        };
      }

    case SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_FAILURE:
      // The request is failed
      return {
        ...state,
        confirmEditCuotaAsyncPending: false,
        confirmEditCuotaAsyncError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA_ASYNC_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        confirmEditCuotaAsyncError: null,
      };

    default:
      return state;
  }
}
